import { CompaniesEmployeeGraph } from '@/components/admin/CompaniesEmployeeGraph';
import { EventsDistributionGraph } from '@/components/admin/EventsDistributionGraph';
import { PriceIncreasesGraph } from '@/components/admin/PriceIncreasesGraph';
import { YearlyPriceIncreasesGraph } from '@/components/admin/YearlyPriceIncreasesGraph';
import { CategoryDistributionGraph } from '@/components/admin/CategoryDistributionGraph';

export const AdminStatsTab = () => {
  return (
    <div className="mt-4 space-y-8">
      <div className="grid grid-cols-2 gap-8">
        <CompaniesEmployeeGraph />
        <EventsDistributionGraph />
      </div>
      <PriceIncreasesGraph />
      <YearlyPriceIncreasesGraph />
      <CategoryDistributionGraph />
    </div>
  );
};